import React, { useState, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

import './NavBar.css'
import ArrowRightSvg from './assets/ArrowRightSvg'
import { Collapse } from 'react-bootstrap'
import StructureSvg from './assets/StructureSvg'
import { ReactComponent as Curriculum } from './assets/Curriculum.svg'
import { ReactComponent as Finance } from './assets/Finance.svg'
import { ReactComponent as Evaluation } from './assets/Evaluation.svg'
import { ReactComponent as Assessment } from './assets/Assessment.svg'
import { ReactComponent as Advisor } from './assets/Advisor.svg'
import { ReactComponent as Transfer } from './assets/Transfer.svg'
import { ReactComponent as Transcript } from './assets/Transcript.svg'
import { ReactComponent as Graduation } from './assets/Graduation.svg'
import { ReactComponent as RoleAndPrm } from './assets/RoleAndPrm.svg'
import { ReactComponent as Register } from './assets/Register.svg'
import { ReactComponent as Classroom } from './assets/Classroom.svg'
import { ReactComponent as Notification } from './assets/Notification.svg'

export default function SideNav({ isToggle }) {
  const [currentMenuCodes, setCurrentMenuCodes] = useState([])
  const [navBarMenus, setNavBarMenus] = useState([])
  const [hoveredMenu, setHoveredMenu] = useState(null)

  const location = useLocation()
  const history = useHistory()

  const roleMenus = useSelector(state => state.authen.user.roleMenus)
  const user = useSelector(state => state.authen.user)

  useEffect(() => {
    setInitialFocusMainMenu(roleMenus)
  }, [roleMenus])

  useEffect(() => {
    const getCurrentMenuCodesByUrl = () => {
      if (location.pathname && Array.isArray(navBarMenus)) {
        const currentMenuId = getCurrentMenuCode(navBarMenus)
        if (currentMenuId) {
          const parentMenuCodesList = findAllParentIds(navBarMenus, currentMenuId)
          setCurrentMenuCodes(parentMenuCodesList)
        }
      }
    }

    getCurrentMenuCodesByUrl()
  }, [navBarMenus, location.pathname])

  const setInitialFocusMainMenu = roleMenus => {
    const menuMap = roleMenus.reduce((map, menu) => {
      menu.subMenus = []
      menu.isShowSubmenu = false
      map[menu.menuId] = menu
      menu.menuIcon = setMainMenuIcon(menu.menuId)

      return map
    }, {})

    // Separate top-level menus and build the menu tree
    const topLevelMenus = roleMenus.filter(menu => {
      if (menu.menuType === 1) {
        return true
      } else if (menuMap[menu.parentMenuId]) {
        menuMap[menu.parentMenuId].subMenus.push(menu)
        return false
      }
    })

    const result = topLevelMenus

    if (result.length > 0) {
      result[0].isShowSubmenu = true
    }
    console.log(result)
    // return result
    setNavBarMenus(result)
  }

  const setMainMenuIcon = menuId => {
    switch (menuId) {
      case 9900:
        return <Curriculum />
      case 9200:
        return <Finance />
      case 9300:
        return <Evaluation />
      case 9400:
        return <Assessment />
      case 9500:
        return <Advisor />
      case 9600:
        return <Transfer />
      case 9700:
        return <Transcript />
      case 9800:
        return <Graduation />
      case 9924:
        return <Classroom />
      case 10000:
        return <RoleAndPrm />
      case 10100:
        return <Register />

      case 10200:
        return <Notification />
      default:
        console.log('have no menu')
    }
  }

  function findAllParentIds(menuArray, targetId, parentIds = []) {
    for (let menu of menuArray) {
      if (menu.menuId === targetId) {
        return [...parentIds, menu.menuId]
      }

      if (menu.subMenus && menu.subMenus.length > 0) {
        const result = findAllParentIds(menu.subMenus, targetId, [...parentIds, menu.menuId])
        if (result) {
          return result
        }
      }
    }

    return null
  }

  const getCurrentMenuCode = menus => {
    if (Array.isArray(menus)) {
      for (const menu of menus) {
        const { menuUrl, subMenus, menuId } = menu
        if (Array.isArray(subMenus) && subMenus.length > 0) {
          const currentMenuCode = getCurrentMenuCode(subMenus) || ''

          if (currentMenuCode) {
            return currentMenuCode
          }
        } else if (typeof menuUrl === 'string' && location.pathname.includes(menuUrl)) {
          return menuId
        }
      }
    }
  }

  const handleChildMenuClick = menuUrl => {
    history.push(menuUrl)
  }

  const handleMouseEnter = menuId => {
    setHoveredMenu(menuId)
  }

  const handleMouseLeave = () => {
    setHoveredMenu(null)
  }

  return (
    <div className={`navBar_container ${isToggle ? 'toggle' : ''}`}>
      <div className={`logo-box ${isToggle ? 'justify-content-center' : 'pl-3'}`}>
        <span style={{ background: '#EEEEEE', width: 40, height: 40, borderRadius: '50%', textAlign: 'center' }}>
          <img
            src={`${process.env.PUBLIC_URL}/img/KU_Logo_PNG.png`}
            alt="Kasetsart University"
            style={{ width: 23, height: 28, marginTop: 5 }}
            className="profile-avatar rounded-circle"
          />
        </span>
        <div className={`ml-3 ${isToggle && 'd-none'}`} style={{ fontSize: 12, color: '#03A96B', fontWeight: 'bold' }}>
          {user && user.firstNameTh + ' ' + user.lastNameTh}
        </div>
      </div>

      <div className="menus-box unext-scrollbar">
        {Array.isArray(navBarMenus) && navBarMenus.length > 0 && (
          <MenuBox
            isToggle={isToggle}
            currentMenuCodes={currentMenuCodes}
            menus={navBarMenus}
            onChildMenuClick={handleChildMenuClick}
            hoveredMenu={hoveredMenu}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          />
        )}
      </div>
    </div>
  )
}

const MenuBox = ({ isToggle, menus, onChildMenuClick, currentMenuCodes, hoveredMenu, onMouseEnter, onMouseLeave }) => {
  const [menuCodeShowCollapse, setMenuCodeShowCollapse] = useState('')

  useEffect(() => {
    setInitialMenuCodeShowCollapse()
  }, [menus, currentMenuCodes])

  const setInitialMenuCodeShowCollapse = () => {
    if (Array.isArray(menus) && Array.isArray(currentMenuCodes) && currentMenuCodes.length > 0) {
      const foundShowCollapseMenu = menus.find(menu => currentMenuCodes.includes(menu.menuId))

      if (foundShowCollapseMenu) {
        setMenuCodeShowCollapse(foundShowCollapseMenu.menuId)
      }
    }
  }

  const handleMenuClick = (menuItem, isParent) => {
    const { menuId, menuUrl } = menuItem

    if (!isParent && onChildMenuClick) {
      onChildMenuClick(menuUrl)
    } else if (isParent) {
      setMenuCodeShowCollapse(prevMenuCode => {
        let newMenuCode = ''

        // there's no open menu or click new menu
        if (!prevMenuCode || (prevMenuCode && prevMenuCode !== menuId)) {
          newMenuCode = menuId
        }

        return newMenuCode
      })
    }
  }

  return (
    <div className="m-0">
      {menus.map(menuItem => {
        const { menuId, menuNameTh, menuType, menuIcon, subMenus } = menuItem
        const paddingLeft = menuType > 1 ? 16 + (menuType - 1) * 24 : ''
        const isParent = Array.isArray(subMenus) && subMenus.length > 0
        const isActiveParentMenu = currentMenuCodes.includes(menuId) && isParent
        const isActiveCurrentMenu = currentMenuCodes.includes(menuId) && !isParent
        const isShowCollapse = menuCodeShowCollapse === menuId

        return (
          <div
            style={menuType === 1 && !isToggle ? { borderBottom: '1px solid' } : {}}
            className={`my-2 ${menuType === 1 && !isToggle && ' py-2 '}`}
            key={menuId}
            onMouseEnter={() => onMouseEnter(menuId)}
            onMouseLeave={onMouseLeave}
          >
            {isToggle && menuType === 1 ? (
              <MenuSmall
                icon={menuIcon}
                isActiveMenu={isActiveParentMenu}
                isActiveCurrentMenu={isActiveCurrentMenu}
                isHovered={hoveredMenu === menuId}
                parentMenu={menuItem}
                currentMenuCodes={currentMenuCodes}
                hoveredMenu={hoveredMenu}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onChildMenuClick={onChildMenuClick}
              />
            ) : (
              <>
                <Menu
                  icon={menuIcon}
                  text={menuNameTh}
                  paddingLeft={paddingLeft}
                  onMenuClick={() => handleMenuClick(menuItem, isParent)}
                  isActiveParentMenu={isActiveParentMenu}
                  isActiveCurrentMenu={isActiveCurrentMenu}
                  isParent={isParent}
                  isShowCollapse={isShowCollapse}
                  menuType={menuType}
                />
                {subMenus && (
                  <Collapse in={isShowCollapse}>
                    <div>
                      <MenuBox
                        isToggle={isToggle}
                        currentMenuCodes={currentMenuCodes}
                        menus={subMenus}
                        onChildMenuClick={onChildMenuClick}
                        hoveredMenu={hoveredMenu}
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}
                      />
                    </div>
                  </Collapse>
                )}
              </>
            )}
          </div>
        )
      })}
    </div>
  )
}

const MenuSmall = ({ icon, isActiveMenu, parentMenu, currentMenuCodes, hoveredMenu, onMouseEnter, onChildMenuClick }) => {
  return (
    <div className={'menuSmall_container'}>
      <div className={`icon ${isActiveMenu ? 'menu-active' : ''}`} onMouseEnter={() => onMouseEnter(parentMenu.menuId)}>
        {icon || <StructureSvg />}
        {hoveredMenu === parentMenu.menuId && (
          <div className="popup">
            <ParentMenu parentMenu={parentMenu} currentMenuCodes={currentMenuCodes} hoveredMenu={hoveredMenu} onChildMenuClick={onChildMenuClick} />
          </div>
        )}
      </div>
    </div>
  )
}

const Menu = ({ icon, text, paddingLeft, isActiveCurrentMenu, isActiveParentMenu, isShowCollapse, onMenuClick, isParent, menuType }) => {
  return (
    <li
      className={`menu_container  ${isActiveParentMenu ? `menu-active ` : ''} ${isActiveCurrentMenu ? 'sub-menu-active' : ''}`}
      onClick={onMenuClick}
      style={{ paddingLeft: paddingLeft }}
    >
      {isParent && menuType === 1 && <div className="icon">{icon || <StructureSvg />}</div>}

      <div className="text">{text}</div>
      {isParent && (
        <div className={`arrow ${isShowCollapse ? 'up' : 'down'}`}>
          <ArrowRightSvg />
        </div>
      )}
    </li>
  )
}

const ParentMenu = ({ parentMenu, currentMenuCodes, hoveredMenu, onChildMenuClick }) => {
  const { menuNameTh, subMenus, menuType } = parentMenu
  const [subMenuHoverId, setSubMenuHoverId] = useState()

  return (
    <div>
      {menuType === 1 && <div className="p-2 text border border-white border-top-0 border-left-0 border-right-0">{menuNameTh}</div>}
      <ul>
        {subMenus.map(subMenu => (
          <li
            key={subMenu.menuId}
            className={currentMenuCodes.includes(subMenu.menuId) ? 'menu-actives' : ''}
            onMouseEnter={() => {
              setSubMenuHoverId(subMenu.menuId)
            }}
            onClick={() => {
              subMenu.subMenus && subMenu.subMenus.length === 0 && onChildMenuClick(subMenu.menuUrl)
              subMenu.subMenus && subMenu.subMenus.length === 0 && console.log(subMenu.menuUrl, subMenu.menuId)
            }}
          >
            {subMenu.menuNameTh}
            {subMenuHoverId === subMenu.menuId && subMenu.subMenus && subMenu.subMenus.length > 0 && (
              <div className="popup">
                <ParentMenu parentMenu={subMenu} currentMenuCodes={currentMenuCodes} hoveredMenu={hoveredMenu} onChildMenuClick={onChildMenuClick} />
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}
